import axios from 'axios';

export const axiosRequest = axios.create();

axiosRequest.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
